import { styled } from 'styled-components';

import { mq, colBothMiddle, rowBothMiddle } from '@/shared/ui/styled';

export const StyledFavoriteBlockContainer = styled.section`
    margin-top: 40px;

    ${mq.lt.md} {
        margin-top: 16px;
    }
`;

export const StyledFavoriteEmptyContainer = styled.section`
    ${colBothMiddle};
    margin: 54px 0 100px;
`;

export const StyledFavoriteEmptyTitle = styled.h4`
    font-size: ${({ theme }) => theme.fontSize.lg};
    color: ${({ theme }) => theme.color.dark};
    font-weight: 500;
    margin: 24px 0 10px;
`;

export const StyledFavoriteEmptySubtitle = styled.p`
    ${rowBothMiddle};
    font-size: ${({ theme }) => theme.fontSize.md};
    color: ${({ theme }) => theme.color.dark};
    margin-bottom: 27px;

    svg {
        margin-left: 8px;
    }
`;

export const StyledFavoriteEmptyLink = styled.div`
    ${rowBothMiddle};
    font-size: ${({ theme }) => theme.fontSize.md};
    color: ${({ theme }) => theme.color.secondary};
    background: ${({ theme }) => theme.color.dark};
    border-radius: 8px;
    padding: 10px 16px;
    font-weight: 700;
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.color.secondary};
    }

    svg {
        margin-right: 8px;
    }
`;

export const StyledFavoriteLoader = styled.div`
    ${rowBothMiddle};
    margin-top: 54px;
`;
